module.exports = __webpack_public_path__ + "media/images/help/cb-license-agree-7b601d1e838624750f0e9aa701a2bc3e.png";